import React, { useEffect, useState } from "react";

import PretendardText from "../../atoms/text/pretendardText";
import SearchBar from "../../atoms/input/searchBar";

import Popup from "../../molecules/popup";

import PopupOverLay from "../PopupOverlay";
import ProductApi from "../../../api/product.api";
import { errorHandler } from "../../../util/errorHandler";
import Empty from "../../molecules/empty";
import styled from "styled-components";
import { toast } from "react-toastify";
import { homepage } from "../../../api/api";

const RelatedProductsPopup = ({
  setPopupOpen,
  setValue,
  value,
  exclusionList,
  setLink,
}) => {
  const [keyword, setKeyword] = useState("");
  const [productList, setProductList] = useState([]);

  useEffect(() => {
    getMerchList();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //  상품  가져오기
  const getMerchList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        sort: "orderNumber",
        orderBy: "ASC",
        saveStatus: "Y",
      };

      if (keyword) {
        data.keyword = keyword;
      }

      const response = (await ProductApi.getListProduct(data)).data.data
        .content;

      let temp = response.map((item) => {
        return {
          id: item.id,
          title: item.title,
        };
      });

      setProductList(temp);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <PopupOverLay
      isOpen={true}
      onClick={() => {
        setPopupOpen(false);
      }}
    >
      <Popup
        headerTitle="연관 상품 추가하기"
        noFooter={true}
        onClick={() => {
          setPopupOpen(false);
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            padding: "0px 30px",
            margin: "16px 0px 20px 0px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <PretendardText
              style={{
                fontSize: "15px",
                fontWeight: "400",
                lineHeight: "22px",
                color: "#aaa",
                marginBottom: 16,
              }}
            >
              추가할 연관상품을 검색하고 선택 버튼을 누르면 반영됩니다.
            </PretendardText>
            <SearchBar
              style={{
                backgroundColor: "#313233",
              }}
              value={keyword}
              onChange={(e) => {
                setKeyword(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  getMerchList();
                }
              }}
              onClick={() => {
                getMerchList();
              }}
            />
            <YScrollCard>
              {productList.length > 0 ? (
                productList.map((item, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 10,
                        padding: "15px 0px",
                        borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                      }}
                    >
                      <PretendardText
                        className="truncate"
                        style={{
                          width: 470,
                          fontSize: "14px",
                          fontWeight: "400",
                          lineHeight: "22px",
                          color: "#aaa",
                        }}
                      >
                        {item.title}
                      </PretendardText>

                      <StyledGrayBtn
                        style={{
                          backgroundColor: "#272829",
                          display: "flex",
                          flexDirection: "row",
                        }}
                        onClick={() => {
                          if (exclusionList) {
                            if (
                              exclusionList.some(
                                (vItem) => vItem.id === item.id
                              )
                            ) {
                              toast(
                                "해당 상품은 쿠폰 적용 범위 및 사용제외 상품과 중복됩니다."
                              );
                              return;
                            }
                          }

                          if (setLink) {
                            let linkTemp = `${homepage}/home/knowledgeStore/category/detail/ebook/${item.id}`;
                            setValue([item]);

                            setLink(linkTemp);
                            setPopupOpen(false);
                            return;
                          }

                          if (value.some((vItem) => vItem.id === item.id)) {
                            let temp = value.filter(
                              (vItemF) => vItemF.id !== item.id
                            );
                            setValue(temp);
                          } else {
                            setValue([...value, item]);
                          }
                        }}
                      >
                        <PretendardText
                          style={{
                            color: "#aaa",
                            fontSize: "14px",
                            fontWeight: "500",
                            lineHeight: "22.75px",
                            textAlign: "center",
                          }}
                        >
                          선택
                        </PretendardText>
                        {value.some((vItem) => vItem.id === item.id) ? (
                          <img
                            style={{
                              marginLeft: 4,
                            }}
                            src="/assets/admin/icons/ico_selectbox_checked.svg"
                            alt="선택됨"
                          />
                        ) : null}
                      </StyledGrayBtn>
                    </div>
                  );
                })
              ) : (
                <Empty
                  style={{
                    width: "100%",
                  }}
                />
              )}
            </YScrollCard>
          </div>
        </div>
      </Popup>
    </PopupOverLay>
  );
};

export default RelatedProductsPopup;

const YScrollCard = styled.div`
  margin-top: 16px;
  width: 100%;
  display: flex;

  flex-direction: column;
  height: 300px;
  overflow-y: auto;
  padding-right: 10px;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #27beff;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 2550, 255, 0.1); /*스크롤바 뒷 배경 색상*/
    border-radius: 10px;
    box-shadow: inset 0px 0px 5px white;
  }
`;

const StyledGrayBtn = styled.button.attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  padding: 3px 8px;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.12);
`;
